import styled from 'styled-components';
import { PropertyFilterInput, useGetPropertiesQuery } from '@/graphql/generated';
import { PropertyForListing } from '@/custom-types';
import { PropertyInfoMiniCard } from '../molecules/PropertyInfoMiniCard';
import { Col, Row } from 'react-grid-system';
import { LoadingSpinner } from '../atoms';
import { capitalizeFirstLetter } from '@/helpers';
import { useNavigate } from 'react-router';
import { pathURL } from '@/components/constants/urls';
import { useErrorHandlerContext, useListNavigationStateContext } from '@/customHooks';

const CardContainer = styled(Col)`
  margin-top: 80px;
`
const dataFlatter = (data: PropertyForListing[] | undefined) => {
  if (!data || data.length === 0) return [];

  return data.map((property) => ({
    id: property.id,
    name: property.name,
    city: property.address.city?.name ?? '',
    state: property.address.state?.name ?? '',
    ownerFirstName: property.owner?.firstName ?? '',
    ownerLastName: property.owner?.lastName ?? '',
    propertyTypeOption: property.typeOption,
    unities: property.unities,
  }));
};

type PropertyListCardsTableProps = {
  filters: PropertyFilterInput;
};

export const PropertyListCardsTable = ({ filters }: PropertyListCardsTableProps) => {
  const { open: errorHandle } = useErrorHandlerContext();
  const { setListState } = useListNavigationStateContext();

  const { data, error, loading } = useGetPropertiesQuery({
    variables: {
      input: filters,
    },
    fetchPolicy: 'network-only',
  });
  
  const navigate = useNavigate()
  
  const tableData = dataFlatter(data?.properties?.items);
  
  const onClickCardHandle = (id: string) => {
    setListState('properties', {
      currentPage: parseInt(filters.page || '1'),
      filters,
      selectedItemId: id,
    });
    navigate(`/${pathURL.USER}/${pathURL.PROPERTY}/${pathURL.DETAIL}`, { state: { id }})
  }
  
  if (error) errorHandle(error);
  return (
    <>
      {
        loading
        ? (
          <Row justify='center'>
            <Col xs='content'>
              <LoadingSpinner />
            </Col>
          </Row>
        )
        : (
          <Row gutterWidth={2}>
            {tableData.map((data) => (
              <CardContainer key={data.id} md={3} onClick={() => onClickCardHandle(data.id)}>
                <PropertyInfoMiniCard
                  propertyId={data.id}
                  name={capitalizeFirstLetter(data.name)}
                  address={`${data.city}, ${data.state}`}
                  unities={data.unities}
                />
              </CardContainer>
            ))}
          </Row>
        )
      }
    </>

  );
};
